import React, {Fragment} from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import LocationIcon from './LocationIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PhoneIcon from './PhoneIcon';
import EmailIcon from './EmailIcon';
import {makeStyles} from '@material-ui/core/styles';

import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 600,
    fontSize: '1rem',
  },
  subtitle: (props) => ({
    fontWeight: 300,
    fontSize: '.9rem',
    color: props.column
      ? theme.palette.primary.main
      : theme.palette.common.white,
  }),
  info: {
    paddingTop: 25,
  },
  smallIcon: (props) => ({
    minWidth: 40,
    color: props.column
      ? theme.palette.primary.main
      : theme.palette.common.white,
    '& > path': {
      fill: props.column
        ? theme.palette.primary.main
        : theme.palette.common.white,
    },
  }),
  phone: (props) => ({
    order: props.column ? 3 : 2,
    fontWeight: props.column ? 600 : 300,
  }),
  subtitlePhone: (props) => ({
    fontWeight: props.column ? 600 : 300,
  }),
}));

const InformationList = ({column, primary}) => {
  const classes = useStyles({column});

  return (
    <Fragment>
      <Grid xs={12} md={column ? 12 : 3} item>
        {!column && (
          <Typography className={classes.title} variant="h6" component="h4">
            CONTÁCTANOS
          </Typography>
        )}
        <List component="nav" aria-label="main mailbox folders">
          <ListItem>
            <ListItemIcon className={classes.smallIcon}>
              <LocationIcon primary={primary} color="inherit" />
            </ListItemIcon>
            <ListItemText
              className={classes.subtitle}
              disableTypography
              primary="Vía 40 No. 69 - 58 Bodega D8 Barranquilla, Colombia"
            />
          </ListItem>
        </List>
      </Grid>
      <Grid xs={12} md={column ? 12 : 2} item className={classes.phone}>
        <List
          className={classes.info}
          component="nav"
          aria-label="main mailbox folders"
        >
          <ListItem>
            <ListItemIcon className={classes.smallIcon}>
              <PhoneIcon primary={primary} color="inherit" />
            </ListItemIcon>
            <ListItemText
              className={clsx(classes.subtitle, classes.subtitlePhone)}
              disableTypography
              primary="+(57) 323 4793073"
            />
          </ListItem>
        </List>
      </Grid>
      <Grid xs={12} md={column ? 12 : 4} item>
        <List
          className={classes.info}
          component="nav"
          aria-label="main mailbox folders"
        >
          <ListItem>
            <ListItemIcon className={classes.smallIcon}>
              <EmailIcon primary={primary} color="inherit" />
            </ListItemIcon>
            <ListItemText
              className={classes.subtitle}
              disableTypography
              primary="mercadeo@estrategias-ltda.com"
            />
          </ListItem>
        </List>
      </Grid>
    </Fragment>
  );
};

export default InformationList;
